<template>
  <div>
    <v-card-title>
      <span class="headline">Meus Emails </span>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Ex: título, remetente, segmento"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="$store.state.emails"
      class="elevation-1"      
      :search="search"
    >      
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.name">
            <td class="text-xs-left">{{item.sender}}</td>
            <td class="text-xs-left">{{item.title}}</td>
            <td class="text-xs-left">{{formatSchedule(item)}}</td>
            <td class="text-xs-left">
              <v-chip v-for="s in item.lead_segments" :key="s.id">{{s.name}}</v-chip>
            </td>
            <td>
              <v-btn @click="remove(item.id)" title="Remover segmento" fab dark small color="error">
                <v-icon dark>remove</v-icon>
              </v-btn>
              <v-btn @click="edit(item)" fab dark small color="cyan">
                <v-icon dark>edit</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>    
  </div>
</template>

<script>  
  import moment from 'moment';
  export default {
    name: 'EmailsList',
    created () {      
      this.fetchEmails();
    },
    watch: {
      // call again the method if the route changes
      '$route': 'fetchEmails'
    },
    methods: {
      fetchEmails() {        
        this.$store.dispatch('fetchEmails');
      },
      remove(data) {
        if (confirm('Tem certeza que quer apagar?')) {
          this.$store.dispatch('deleteEmail', {params: {id: data}})
        }
      },
      edit(data) {        
        this.$emit('edit', data)
      },
      formatSchedule(email) {
        switch(email.schedule) {
          case 1:
            return 'Diariamente';
          case 2:
            return 'Mensalmente';
          case 3:
            return moment(email.schedule_date).format('DD/MM/YYYY');
          case 4:
            return email.schedule_days + ' dias';
        }
      },
    },
    computed: {
    },
    data () {
      return {
        search: '',        
        headers: [
          {text: 'Remetente', value: 'sender'},
          {text: 'Título', value: 'title'},
          {text: 'Agendamento', value: 'schedule'},
          {text: 'Segmentos', value: 'lead_segments'}
        ],
      }
    },
  }
</script>
<style lang="css" scoped>
</style>